import { useEffect } from "react";

const GA = ({ trackingId }) => {
/*   useEffect(() => {
    const loadGA = () => {
      if (typeof window !== "undefined" && !window.gtag) {
        // Inject the Google Analytics script
        const script = document.createElement("script");
        script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
        script.async = true;
        script.onload = () => {
          console.log("Google Analytics Loaded");
          // Initialize Google Analytics once the script has loaded
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            window.dataLayer.push(arguments);
          }
          gtag("js", new Date());
          gtag("config", trackingId);
        };
        document.head.appendChild(script);
      }
    };

    // Load GA script asynchronously
    setTimeout(() => {
      loadGA();
    }, 3800);
  }, [trackingId]);
 */
  return null; // No need to render anything
};

export default GA;
